/**
 * @license
 * Copyright 2024 Ada School
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { TranslatedField } from "../schemaTypes";

type CustomErrorOptions = {
  status?: number;
  message?: string;
  translations?: TranslatedField[];
  code?: string;
};

export class ErrorWithTranslations extends Error {
  status: number;

  translations: TranslatedField[];

  code: string | undefined;

  constructor({ status, message, translations, code }: CustomErrorOptions) {
    super(message);
    this.message = message ?? "Internal Server Error";
    this.status = status ?? 500;
    this.translations = translations ?? [];
    this.code = code;
  }
}
